import type { AgentMessage } from '../../../types/AgentMessage';
import { translate } from '../../common/helpers/translate.helper';
import type { AgentFormInitialValues, AgentFormValues } from '../AgentForm/AgentForm';
import { AgentForm } from '../AgentForm/AgentForm';
import { useAgentCreate } from '../useAgentCreate';

interface CreateAgentFormProps {
    data: AgentFormInitialValues;
    comment?: string;
    onSuccess?: (agent: AgentMessage) => void;
    showCompanySelect?: boolean;
}

export const CreateAgentForm = ({ data, comment, onSuccess, showCompanySelect }: CreateAgentFormProps) => {
    const createAgentMutation = useAgentCreate(onSuccess);

    const handleSubmit = async (agent: AgentFormValues) => {
        try {
            await createAgentMutation.mutateAsync({ agent });
        } catch {
            return;
        }
    };

    return (
        <AgentForm
            primaryActionText={translate('agents.createAgent')}
            onSubmit={handleSubmit}
            agent={data}
            showCompanySelect={showCompanySelect}
            comment={comment}
        />
    );
};
